var _path, _g, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSliderField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 6,
    viewBox: "0 0 15 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24268_6543)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24268_6543",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 8,
    height: 2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5498H7.29V3.9548H0V2.5498Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24268_6543)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.138 3.2568C7.138 3.5058 7.191 3.7418 7.285 3.9548H0.527C0.237 3.9548 0 3.7178 0 3.4278V3.0768C0 2.7868 0.237 2.5498 0.527 2.5498H7.29C7.192 2.7658 7.138 3.0048 7.138 3.2568Z",
    fill: "#676879"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.1875H13.976",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5852 3.25816C10.5852 3.37816 10.5732 3.49616 10.5492 3.61016C10.3862 4.39316 9.69218 4.98116 8.86118 4.98116C8.31118 4.98116 7.82218 4.72416 7.50718 4.32316L7.47018 4.27316C7.43318 4.22516 7.40018 4.17316 7.37018 4.12016L7.34018 4.06616C7.32018 4.03016 7.30218 3.99316 7.28618 3.95616C7.19118 3.74216 7.13818 3.50616 7.13818 3.25816C7.13818 3.00616 7.19218 2.76616 7.29018 2.55016C7.32318 2.47516 7.36218 2.40316 7.40618 2.33516L7.44018 2.28416C7.45018 2.26716 7.46318 2.25116 7.47618 2.23416L7.50018 2.20116L7.52018 2.17716L7.55018 2.14016C7.56318 2.12416 7.57618 2.10916 7.59018 2.09516L7.64618 2.03516L7.69418 1.99016L7.72018 1.96716C7.75018 1.94016 7.78118 1.91416 7.81418 1.88916L7.84018 1.87016L7.89818 1.82916C7.94418 1.79816 7.99118 1.76916 8.04018 1.74216L8.11418 1.70516L8.18418 1.67316C8.20618 1.66316 8.22918 1.65316 8.25418 1.64516L8.28518 1.63316C8.33518 1.61516 8.38718 1.60016 8.44018 1.58616L8.51318 1.57016H8.51518L8.59918 1.55516C8.63218 1.55016 8.66618 1.54616 8.69918 1.54316C8.71718 1.54116 8.73518 1.53916 8.75318 1.53916L8.78818 1.53716L8.86118 1.53516H8.86518L8.94518 1.53716L9.02018 1.54316L9.06418 1.54816C9.07918 1.54916 9.09418 1.55016 9.10718 1.55316L9.14818 1.55916L9.18218 1.56616L9.22018 1.57316C9.24018 1.57716 9.26018 1.58116 9.27818 1.58716L9.29818 1.59116L9.34018 1.60316L9.38118 1.61616C9.42818 1.63016 9.47518 1.64716 9.51918 1.66616L9.56918 1.68816C9.60118 1.70116 9.63318 1.71616 9.66318 1.73316L9.70718 1.75716C9.76218 1.78716 9.81418 1.82116 9.86518 1.85916L9.89718 1.88216C9.94718 1.91816 9.99318 1.95716 10.0372 1.99916L10.0732 2.03416L10.1162 2.07816L10.1562 2.12316L10.1662 2.13316L10.2062 2.18316C10.3742 2.39016 10.4932 2.63716 10.5492 2.90616C10.5732 3.02016 10.5852 3.13716 10.5852 3.25816Z",
    stroke: "#676879"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24268_6543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 5,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderField);
export default __webpack_public_path__ + "static/media/slider-field.e5bc20aa.svg";
export { ForwardRef as ReactComponent };